import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientConditionCheckUp from './patient-condition-check-up';
import PatientConditionCheckUpDetail from './patient-condition-check-up-detail';
import PatientConditionCheckUpUpdate from './patient-condition-check-up-update';
import PatientConditionCheckUpDeleteDialog from './patient-condition-check-up-delete-dialog';

const PatientConditionCheckUpRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientConditionCheckUp />} />
    <Route path="new" element={<PatientConditionCheckUpUpdate />} />
    <Route path=":id">
      <Route index element={<PatientConditionCheckUpDetail />} />
      <Route path="edit" element={<PatientConditionCheckUpUpdate />} />
      <Route path="delete" element={<PatientConditionCheckUpDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientConditionCheckUpRoutes;
